import { groupBy, reduce } from 'lodash';
import { createSelector } from 'reselect';
import {
  buildTimelineCollection,
  GroupedBoundingPoly,
  BoundingPolyTree,
} from '@worker';
import { selectDetectionsFlattened } from './detections';
import { selectMediaDuration, selectFrameRate } from './view';
import { DetectionBoundingPoly } from '@common-modules/mediaDetails/models';
import { convertToFilterParameterType } from '@utils';

export const selectDetectionCollections = createSelector(
  selectMediaDuration,
  selectDetectionsFlattened,
  selectFrameRate,
  // selectManualInterpolationMax,
  // selectAutoInterpolationMax,
  (
    mediaDuration,
    detections,
    fps
    // manualInterpolationMax,
    // autoInterpolationMax
  ): { [key: string]: BoundingPolyTree | undefined } => {
    const detectionsGroupedByType: {
      [key: string]: DetectionBoundingPoly[];
    } = groupBy(detections, ({ object: { type } }) =>
      convertToFilterParameterType(type)
    );

    // const filterByManualInterpolation = filterList.includes('manualInterp');

    const detectionCollections = reduce(
      detectionsGroupedByType,
      (
        res: { [key: string]: BoundingPolyTree | undefined },
        boundingPolyList: DetectionBoundingPoly[],
        label: string
      ) => {
        // if (filterByManualInterpolation) {
        //   filteredBoundingPolys = boundingPolyList.filter(
        //     ({ startTimeMs, stopTimeMs, object: { overlayObjectType } }) => {
        //       if (overlayObjectType !== 'interpolation') {
        //         return false;
        //       }
        //       const len = stopTimeMs - startTimeMs;
        //       return len > autoInterpolationMax && len < manualInterpolationMax;
        //     }
        //   );
        // } else

        // convert to GroupedBoundingPoly (needs better name like CollectionBoundingPoly)
        const boundingPolys: GroupedBoundingPoly[] = boundingPolyList.map(
          (f) => ({
            id: f.id,
            subsegmentId: f.subsegmentId,
            groupId: f.groupId,
            clusterId: f.clusterId,
            type: f.object.type,
            startTimeMs: f.startTimeMs,
            stopTimeMs: f.stopTimeMs,
            boundingPoly: f.object.boundingPoly,
            isDeleted: f.object.isDeleted,
            isEditable: true,
            shapeType: f.shapeType,
            redactionCode: f.redactionCode,
            redactionConfig: f.redactionConfig,
            version: f.version,
          })
        );

        // this is call to the legacy build method
        // res[label] = buildTimelineCollection(
        //   1, // 1 second leaf span produces a much smaller tree - faster to pass from worker to main
        //   [0, mediaDuration * 1000],
        //   Date.now()
        // )(boundingPolys);

        res[label] = buildTimelineCollection(
          boundingPolys,
          0,
          mediaDuration,
          1, // 1 second leaf span produces a much smaller tree - faster to pass from worker to main and update
          Date.now(),
          fps
        );

        return res;
      },
      {} as { [key: string]: BoundingPolyTree | undefined }
    );

    return detectionCollections;
  }
);
